import { useMutation } from '@tanstack/react-query';
import Notify from '@/components/Notification';
import { getMessage } from '@/helpers/utils';
import { userService } from '../../services/userService';

export const useChangePassword = () => {
  return useMutation({
    mutationFn: payload =>
      userService.changePassword(payload).then(response => {
        const { status, data } = response;
        const message = getMessage(data);

        if (status === 200) {
          Notify.success({ text: message });
          return data;
        }

        Notify.error({
          text:
            (data && data.errors && data.errors.non_field_errors[0]) ||
            message ||
            'Could not change password',
        });

        return null;
      }),
  });
};
